module.exports = __webpack_public_path__ + "static/media/SC-Mini-1.1afd52a4.jpg";